import { AxiosError } from 'axios';
import { get } from '@/utils';
import { ISubscribedProject } from './types';

type SubscribedProjectsResponse = {
	items: ISubscribedProject[];
	pageNumber: number;
	totalPages: number;
	totalCount: number;
	orderBy: string | null;
	ascending: boolean;
	hasPreviousPage: boolean;
	hasNextPage: boolean;
};

const appendPaginationParams = (query: string, page: number, items: number): string => {
	const separator = query.includes('?') ? '&' : '?';
	return `${query}${separator}PageNumber=${page + 1}&PageSize=${items}`;
};

async function fetchSubscriptions(
	userId: number | string,
	page: number,
	items: number,
	onResponse?: (page: number, items: number) => void
): Promise<ISubscribedProject[]> {
	try {
		const res = await get(
			`api/users/${userId}/subscribed-projects?PageNumber=${page + 1}&PageSize=${items}`
		);
		const data = res.data as SubscribedProjectsResponse;
		onResponse?.(data.totalPages, data.totalCount);
		return data.items || [];
	} catch (e) {
		const error = e as AxiosError;
		const data = error.response?.data as { error: string };
		throw new Error(data?.error || 'Nu am reușit să accesăm datele.');
	}
}

async function fetchQuerySubscriptions(
	userId: number | string,
	query: string,
	page: number,
	items: number,
	onResponse?: (page: number, items: number) => void
): Promise<ISubscribedProject[]> {
	try {
		const res = await get(
			`api/users/${userId}/subscribed-projects${appendPaginationParams(query, page, items)}`
		);
		const data = res.data as SubscribedProjectsResponse;
		onResponse?.(data.totalPages, data.totalCount);
		return data.items || [];
	} catch (e) {
		const error = e as AxiosError;
		const data = error.response?.data as { error: string };
		throw new Error(data?.error || 'Nu am reușit să accesăm datele.');
	}
}

export { fetchSubscriptions, fetchQuerySubscriptions };
